<template>
  <button
    type="button"
    class="btn-plain"
    :class="[
      favorite ? 'btn-heart-fill' : 'btn-heart',
      fromSearchBar ? 'custom- mt-2' : '',
    ]"
    :disabled="toggledisabled"
  >
    <!-- Filled bookmark SVG for SearchBar -->
    <svg
      v-if="fromSearchBar"
      width="23"
      height="29"
      viewBox="0 0 23 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bookmark-svg"
      :class="{ 'favorite-active': favorite }"
    >
      <path
        d="M2 1.5H21C21.2761 1.5 21.5 1.72386 21.5 2V26.3076C21.5 26.78 20.9058 26.9887 20.6104 26.6201L13.4502 17.6904L13.3545 17.5771C12.3652 16.4795 10.6348 16.4795 9.64551 17.5771L9.5498 17.6904L2.38965 26.6201C2.09418 26.9887 1.5 26.78 1.5 26.3076V2C1.5 1.72386 1.72386 1.5 2 1.5Z"
        :fill="favorite ? '#62a4fd' : 'white'"
        :stroke="favorite ? '#62a4fd' : '#000000'"
        stroke-width="3"
      />
    </svg>
    
    <!-- Filled bookmark SVG for table rows -->
    <svg
      v-else
      width="20"
      height="27"
      viewBox="0 0 20 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="bookmark-svg"
      :class="{ 'favorite-active': favorite }"
    >
      <path
        d="M2 1H18C18.5523 1 19 1.44772 19 2V24.5858C19 25.4767 17.9229 25.9229 17.2929 25.2929L11.7071 19.7071C10.7165 18.7165 9.2835 18.7165 8.29289 19.7071L2.70711 25.2929C2.07714 25.9229 1 25.4767 1 24.5858V2C1 1.44772 1.44772 1 2 1Z"
        :fill="favorite ? '#62a4fd' : 'white'"
        :stroke="favorite ? '#62a4fd' : '#000000'"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'Favorite',
  props: ['favorite', 'toggledisabled', 'fromSearchBar'],
};
</script>

<style scoped>
.btn-plain.custom-size {
  margin-top: 10px;
}

.bookmark-svg {
  transition: all 0.2s ease;
  height: 30px; /* Increased from 27px to 30px */
}

.bookmark-svg.favorite-active {
  filter: brightness(0.9);
}

.custom-size .bookmark-svg {
  transform: scale(1.2);
}

.prof-head-left .btn-heart:hover .bookmark-svg,
.one-right .btn-heart:hover .bookmark-svg {
  filter: brightness(0.8);
}

.prof-head-left .btn-heart-fill:hover .bookmark-svg,
.one-right .btn-heart-fill:hover .bookmark-svg {
  filter: brightness(0.7);
}
</style>
